import { render, staticRenderFns } from "./WorkHomeEight.vue?vue&type=template&id=f1a6c90e"
import script from "./WorkHomeEight.vue?vue&type=script&lang=js"
export * from "./WorkHomeEight.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports